import { useQuery } from '@tanstack/react-query';

import Axios from '@/lib/axios-instance';


export const getCustomApiCallSettings = async () => {
  try {
    const response = await Axios.get(`/custom_api_call_router`);

    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useGetCustomApiCallRouter = () => {
  const customApiCallRotuer = useQuery({
    queryKey: ['get_all_custom_api_call_router'],
    queryFn: () => getCustomApiCallSettings(),
  });

  return customApiCallRotuer;
};
